import React from 'react';
import Toast from './Toast';

interface ToastData {
    id: string;
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
    duration?: number;
}

interface ToastContainerProps {
    toasts: ToastData[];
    onRemoveToast: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemoveToast }) => {
    return (
        <>
            {toasts.map((toast, index) => (
                <div
                    key={toast.id}
                    style={{
                        position: 'fixed',
                        top: `${20 + index * 80}px`, // Stack toasts vertically
                        right: '20px',
                        zIndex: 9999,
                    }}
                >
                    <Toast
                        message={toast.message}
                        type={toast.type}
                        isVisible={true}
                        onClose={() => onRemoveToast(toast.id)}
                        duration={toast.duration}
                    />
                </div>
            ))}
        </>
    );
};

export default ToastContainer;